/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { React, useState, useEffect } from "react";
import "./SideBar.css";
import { useButtonConfigStore } from "../pages/Frontend";
import { ConfirmationPromptStore } from "./ConfirmationPrompt";
import { InfoPromptState } from "./InfoPrompt";

function SideBar() {
  const [arMode, setArMode] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("ar") === "1") {
      setArMode(true);
    } else {
      setArMode(false);
    }
  }, []);
  return (
    <div className={arMode ? "SideBar-AR" : "SideBar-XR"}>
      <img
        src="./assets/info_button.svg"
        alt=""
        id="side-i"
        onClick={() => {
          InfoPromptState().setShowInfo(!InfoPromptState().showInfo);
        }}
      />
      {arMode && (
        <>
          <div className="sidebar-divider" />
          <img
            src="./assets/refresh1.svg"
            alt=""
            id="side-replace"
            onClick={() => {
              ConfirmationPromptStore.getState().setShow(true);
            }}
          />
        </>
      )}
    </div>
  );
}

export default SideBar;
